// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1L6tv","rootSmall":"AddTileButton_rootSmall__2SC-a"};